module.exports = __webpack_public_path__ + "static/media/5.61a81036.svg";